import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";



export const loadRole = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/roles/collection').then((response) => {
      commit(types.LOAD_PROFILES, response.data.roles)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const createRole = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/role', data).then((response) => {
      commit(types.ADD_ROLE, response.data.role)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const deleteRole = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete('delete/' + id + '/role').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateRole = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.patch('update/' + data.id + '/role', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getPermissionForProfile = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('role/' + data + '/getPermissionToRole').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const togglePermissionToProfile = (_ctx, {id, data}) => {
  return new Promise((resolve, reject) => {
    window.axios.post('attribute/' + id + '/permission', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const fetchProfile = (_ctx, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/' + id + '/role').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const togglePermissionToUser = (_ctx, {id, data}) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`attribute/${id}/permissions`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
